import type { IconProps } from './../../models/icon';

export function FaceIdIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill={secondaryColor}
          d="M22.6405 22.6408C22.962 22.3193 23.1426 21.8832 23.1426 21.4286V2.57146C23.1426 2.1168 22.962 1.68077 22.6405 1.35928C22.3191 1.03779 21.883 0.857178 21.4284 0.857178H2.57122C2.11656 0.857178 1.68053 1.03779 1.35904 1.35928C1.03755 1.68077 0.856934 2.1168 0.856934 2.57146V21.4286C0.856934 21.8832 1.03755 22.3193 1.35904 22.6408C1.68053 22.9622 2.11656 23.1429 2.57122 23.1429H21.4284C21.883 23.1429 22.3191 22.9622 22.6405 22.6408Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M23.1429 18V21.4286C23.1429 21.8832 22.9622 22.3193 22.6407 22.6407C22.3193 22.9622 21.8832 23.1429 21.4286 23.1429H18"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M18 0.857178H21.4286C21.8832 0.857178 22.3193 1.03779 22.6407 1.35928C22.9622 1.68077 23.1429 2.1168 23.1429 2.57146V6.00003"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M0.856934 6.00003V2.57146C0.856934 2.1168 1.03755 1.68077 1.35904 1.35928C1.68053 1.03779 2.11656 0.857178 2.57122 0.857178H5.99979"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M5.99979 23.1429H2.57122C2.11656 23.1429 1.68053 22.9622 1.35904 22.6407C1.03755 22.3193 0.856934 21.8832 0.856934 21.4286V18"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M6.85693 6V9.42857"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M17.1431 6V9.42857"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M12.0001 7.71423V13.7142H9.42871"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M7.71436 17.1428C8.87085 18.2413 10.405 18.8539 12.0001 18.8539C13.5951 18.8539 15.1293 18.2413 16.2858 17.1428"
        />
      </g>
    </svg>
  );
}
